import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  let headerCheckboxValue = props.isAssignedToAllClients || false;
  let isParentLabel = props.data?.clientName ? false : true;
  // apply indentation when this is NOT the parent label (i.e. it's a child/client)
  const checkboxStyle = isParentLabel ? undefined : { paddingLeft: '2rem' };

  return (
    <span className="mt-1" style={checkboxStyle}>
      <MotifCheckbox
        type="checkbox"
        name="header-checkbox"
        id={`ag-cell-checkbox-${props.data?.analyticsReportName}`}
        checked={props.data?.isAccessGranted || headerCheckboxValue}
        data-testid={
          isParentLabel
            ? 'chkAssignToAllClients'
            : `chkClient-${props.data?.clientName}`
        }
        aria-label="Press Space to toggle row selection"
        tabIndex="-1"
        onClick={() =>
          props.onClientCheckboxChange(
            props.data?.clientID,
            props.node,
            headerCheckboxValue
          )
        }
      >
        {props.data?.clientName ? (
          <span data-testid="lblSelectedClient">{props.data.clientName}</span>
        ) : (
          props.label
        )}
      </MotifCheckbox>
    </span>
  );
};
